import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
import { errorHandling } from "../lib/runtime/errorHandling.js";
import { ErrorMessage } from "./ErrorMessage.js";
export class BlockErrorBoundary extends Component {
    state = {
        hasError: false,
    };
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error };
    }
    componentDidCatch(error, errorInfo) {
        if (errorHandling.onReactError) {
            errorHandling.onReactError({
                type: "block",
                block: this.props.block,
                error,
                componentStack: errorInfo.componentStack,
            });
        }
    }
    render() {
        if (this.state.hasError) {
            const err = this.state.error;
            let display = env.dev ? _jsx(ErrorMessage, { error: err }) : null;
            if (errorHandling.renderFallback) {
                display = errorHandling.renderFallback({
                    type: "block",
                    block: this.props.block,
                    error: err,
                }, display);
            }
            return display;
        }
        return this.props.children;
    }
}
